module.exports = __webpack_public_path__ + "static/rodrigo-923cf9c234dec3254893ca99edf28e30.png";